import { backendApi } from "@/services/backend/api";
import {
  Customer,
  CustomerAddress,
  CustomerViewModel,
} from "@/services/backend/customers/types/customer";
import { Filter } from "@/shared/lib/filter/filter";
import { providesList } from "@/services/backend/_lib/tag-helpers";
import { Lst } from "@/shared/lib/lst/lst";

const customersApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["Customer", "CustomerAddress"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      customersCustomerPut: build.mutation<Customer, PutRequest>({
        query: (request) => ({
          url: `customers/customer`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["Customer"],
      }),
      customersCustomerShow: build.query<Customer, ShowRequest>({
        query: (request) => ({
          url: `/customers/customer`,
          method: "GET",
          params: request,
        }),
        providesTags: (_result, _e, request) => [
          { type: "Customer", id: request.id },
        ],
      }),
      customersCustomerList: build.query<Lst<CustomerViewModel>, ListRequest>({
        query: (request) => ({
          url: `/customers/customer/list`,
          method: "GET",
          params: {
            request: btoa(JSON.stringify(request)),
          },
        }),
        providesTags: (result) => providesList(result?.items, "Customer"),
      }),
      customersCustomerAddressShow: build.query<
        CustomerAddress,
        ShowCustomerAddressRequest
      >({
        query: (request) => ({
          url: `/customers/customer/address`,
          method: "GET",
          params: request,
        }),
        providesTags: (_result, _e, request) => [
          { type: "CustomerAddress", id: request.customerId },
        ],
      }),
      customersCustomerAddressPut: build.mutation<
        CustomerAddress,
        PutCustomerAddressRequest
      >({
        query: (request) => ({
          url: `customers/customer/address`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: (_result, _error, request) => [
          { type: "CustomerAddress", id: request.customerId },
        ],
      }),
    }),
  });

export const {
  useCustomersCustomerPutMutation,
  useCustomersCustomerShowQuery,
  useCustomersCustomerListQuery,
  useCustomersCustomerAddressShowQuery,
  useCustomersCustomerAddressPutMutation,
} = customersApi;

export interface PutRequest {
  id: string;
  name: string;
}

export type PutCustomerAddressRequest = CustomerAddress;

export interface ShowRequest {
  id: string;
}

export interface ListRequest {
  name?: Filter<string>;
  limit?: number;
  offset?: number;
}

export interface ShowCustomerAddressRequest {
  customerId: string;
}
